/**
 * @generated SignedSource<<f74f08c8a44b85f90bd272e8dc11b394>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LinkedStoreProductItem_StoreProduct$data = {
  readonly id: string;
  readonly imageUrl: string | null;
  readonly name: string | null;
  readonly partNumber: string | null;
  readonly " $fragmentType": "LinkedStoreProductItem_StoreProduct";
};
export type LinkedStoreProductItem_StoreProduct$key = {
  readonly " $data"?: LinkedStoreProductItem_StoreProduct$data;
  readonly " $fragmentSpreads": FragmentRefs<"LinkedStoreProductItem_StoreProduct">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LinkedStoreProductItem_StoreProduct",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "partNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "StoreProduct",
  "abstractKey": null
};

(node as any).hash = "a63d40f4ea3d8d006a2e2d13c8c88039";

export default node;
